import { Component } from "@angular/core";

@Component({
  selector: "diaprofil-chart",
  templateUrl: "diaprofil-chart.component.html"
})
export class DiaprofilChart {
  constructor(
  ) {
    // Empty for now
  }

}



// WEBPACK FOOTER //
// ./src/components/diaprofil-chart.component/diaprofil-chart.component.ts